import { Box, InputAdornment, TextField } from '@material-ui/core'
import { Favorite, Search, Share, Visibility } from '@material-ui/icons'
import { Pagination } from '@material-ui/lab'
import Breadcrumbs from 'components/Breadcrumbs'
import Link from 'components/Link'
import NoDataAvailable from 'components/NoDataAvailable'
import SEO from 'components/SEO'
import SessionContext from 'components/session/SessionContext'
import Title from 'components/Title'
import { dateFormatter, fetchFromAPI, fetchPost, getTranslationContent, handleRouter, isArray } from 'functions'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { useContext, useEffect, useState } from 'react'
import useStyles from 'styles/Events.Style'
import useTranslation from 'translations/hooks/useTranslation'

export default function Events(props) {
    const classes = useStyles();
    const router = useRouter();
    const { t } = useTranslation();

    let { session: { lang } } = useContext(SessionContext);
    let isAr = lang === 'ar';

    let page = 1, details = 'all';
    let params = router?.query?.params;

    if (isArray(params)) {
        if (params.length == 1) {
            if (parseInt(params[0])) {
                page = parseInt(params[0]); details = 'all';
            } else {
                page = 1; details = params[0];
            }
        }
        if (params.length > 1) {
            page = parseInt(params[1]) ? parseInt(params[1]) : 1
            details = params[0];
        }
    }

    const [title, setTitle] = useState('');
    const [events, setEvents] = useState(props.events)
    const [eventsCount, setEventsCount] = useState(Math.ceil(props.eventsCount / 6))

    useEffect(() => {
        if (!isArray(params)) handleRouter({ href: '/events/[...params]', as: '/events/1' })

        function fetchData() {
            let reqBody = {
                limit: 8, page, needCount: true, title,
                section: (details == 'oea-support' || details == 'all') ? '' : details
            };

            fetchFromAPI({ api: 'events', reqBody })
                .then(response => {
                    let events = response.response.data;
                    let eventsCount = isArray(response.response.rowsCount) && response.response.rowsCount[0].rowsCount;
                    eventsCount = Math.ceil(eventsCount / 6)
                    setEvents(events);
                    setEventsCount(eventsCount);
                })
        }
        if (title) fetchData()
        else {
            setEvents(props.events)
            setEventsCount(Math.ceil(props.eventsCount / 6))
        }
    }, [title, props.events])//eslint-disable-line react-hooks/exhaustive-deps

    const section = details == 'all' ? '' :
        details == 'oea-support' ? 'OEA-Support' :
            details == 'training-center' ? 'Training-Center' : null;


    var breadcrumbs = [
        { text: t('home'), href: '/' },
        { text: t('events') },
        { text: `${t(section)}` }
    ]

    return (
        <Box display='flex' flexDirection='column' width={'100%'}>
            <SEO
                title={t('events')}
                description={t('eventsDescription')}
            />
            <Breadcrumbs items={breadcrumbs} />
            <Title text={t('events')} />
            <Box className={classes.tab} >
                {['OEA-Support', 'training-Center', 'all'].map(tab => (
                    <Link key={tab} href='/events/[...params]' as={`/events/${tab == 'all' ? '1' : tab.toLowerCase()}`} >
                        <Box className={details == tab.toLowerCase() ? classes.itemSelected + ' ' + classes.item : classes.item} >
                            {t(tab)}
                        </Box>
                    </Link>
                ))}
            </Box>
            <Box className={classes.container}>
                <Box className={classes.eventContent}>
                    <TextField
                        fullWidth
                        variant='outlined'
                        size='small'
                        placeholder={t('searchIn') + " " + t('events')}
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        onFocus={() => { if (page != 1) handleRouter({ href: '/events/[...params]', as: `/events/${details == 'all' ? '1' : details + '/1'}` }) }}
                        className={classes.root}
                        InputProps={{
                            className: classes.multilineColor,
                            endAdornment: (
                                <InputAdornment position='end'>
                                    <Search />
                                </InputAdornment>
                            )
                        }}
                    />
                    {!isArray(events) ?
                        <NoDataAvailable />
                        :
                        <>
                            <Box className={classes.eventContainer}>
                                {events.map(event => (
                                    <Link href='/events/details/[slug]' as={`/events/details/${event.slug}`} key={event._id}>
                                        <Box className={classes.styleEvent}>
                                            <Box className={classes.eventBox}>
                                                <Box className={classes.eventImage}>
                                                    <Image
                                                        src={event.image ? `${event.image}` : '/placeholder.jpg'}
                                                        alt='event image'
                                                        layout='responsive'
                                                        height={320}
                                                        width={500}
                                                    />
                                                </Box>
                                                <Box className={classes.eventDate}>
                                                    {dateFormatter(event.start, 'D MMMM, YYYY', isAr)}
                                                </Box>
                                                <Box className={classes.eventDetails}>
                                                    <Box className={classes.eventText}>
                                                        <Box className={classes.eventTitle + ' partTitle'}>
                                                            {getTranslationContent(event, 'title', lang)}
                                                        </Box>
                                                        <Box className={classes.eventDescription + ' partTextEvent'}>
                                                            {getTranslationContent(event, 'description', lang)}
                                                        </Box>
                                                    </Box>
                                                    <Box className={classes.interactionsSummary}>
                                                        <Box className={classes.interactionsCount}>
                                                            <Box style={{ fontSize: 14, marginLeft: 3 }}>
                                                                {t('shares')}
                                                            </Box>
                                                            <Share style={{ fontSize: 15 }} />
                                                        </Box>
                                                        <Box className={classes.interactionsCount}>
                                                            <Box style={{ fontSize: 14, marginLeft: 3 }}>
                                                                {event?.interactionsSummary?.likes} {t('likes')}
                                                            </Box>
                                                            <Favorite style={{ fontSize: 15, color: event?.interactionsSummary?.likedByMe ? '#F5B750' : '#344450' }} />
                                                        </Box>
                                                        <Box className={classes.interactionsCount}>
                                                            <Box style={{ fontSize: 14, marginLeft: 3 }}>
                                                                {event?.interactionsSummary?.views} {t('views')}
                                                            </Box>
                                                            <Visibility style={{ fontSize: 15 }} />
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Box>
                                            <Box className={classes.yellowLine} />
                                        </Box>
                                    </Link>
                                ))}
                            </Box>
                            {eventsCount > 1 ?
                                <Box className={classes.paginationWrapper}>
                                    <Pagination
                                        page={parseInt(page)}
                                        count={eventsCount}
                                        onChange={(event, value) => handleRouter({ href: `/events/[...params]`, as: `/events/${details == 'all' ? value : details + '/' + value}` })}
                                    />
                                </Box>
                                : null}
                        </>
                    }
                </Box>
            </Box>
        </Box>
    )
}

export async function getServerSideProps(context) {
    let { lang, params = [] } = context?.query;
    let page = 1, details = '';
    if (isArray(params)) {
        if (params.length == 1) {
            if (parseInt(params[0])) {
                page = parseInt(params[0]); details = '';
            } else { page = 1; details = params[0]; }
        }
        if (params.length > 1) {
            page = parseInt(params[1]) ? parseInt(params[1]) : 1
            details = params[0];
        }
    }
    let events = []; let response = {};
    let eventsCount = 0;
    let reqBody = {
        limit: 6,
        page,
        section: details == 'oea-support' ? '' : details,
        needCount: true,
        lang
    };
    (context.req) ?
        response = await fetchPost({ apiName: 'events', reqBody }) :
        response = await fetchFromAPI({ api: 'events', reqBody });
    events = response.response.data;
    eventsCount = isArray(response.response.rowsCount) && response.response.rowsCount[0].rowsCount;
    return { props: { events, eventsCount } }
}